export default "__VITE_ASSET__CwTw5epU__"